<template>
  <div class="sensitive-words-manage">
    <div class="content-box">
      <div class="toolbar">
        <div class="toolbar-left">
          <div class="tip-text">
            <i class="el-icon-info"></i>
            {{$t('channel.sensitiveWordsTip')}}
          </div>
        </div>
        <div class="toolbar-right">
          <el-button type="primary" size="small" @click="showAddDialog" class="add-btn">
            <i class="el-icon-plus"></i>
            {{$t('channel.addSensitiveWords')}}
          </el-button>
        </div>
      </div>

      <el-table
        :data="filteredSensitiveWordsList"
        style="width: 100%"
        v-loading="loading"
        height="calc(100vh - 280px)"
      >
        <el-table-column prop="word_name" :label="$t('channel.wordName')" width="180" header-align="center" />
        <el-table-column prop="description" :label="$t('channel.description')" header-align="center" min-width="180" />
        <el-table-column prop="sensitive_words" :label="$t('channel.sensitiveWords')" header-align="center" min-width="600">
          <template slot-scope="scope">
            <div class="sensitive-words-content">
              {{ formatSensitiveWords(scope.row.sensitive_words) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" :label="$t('channel.updateTime')" width="160" header-align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.updated_at) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('channel.operation')" width="180" fixed="right" header-align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="editSensitiveWords(scope.row)">{{$t('channel.edit')}}</el-button>
            <el-button size="mini" type="danger" @click="deleteSensitiveWords(scope.row)" class="delete-btn">{{$t('channel.delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增/编辑敏感词对话框 -->
    <popup v-if="dialogVisible" @closeEvent="closeDialog">
      <template slot="popup-name">
        <div>{{ dialogTitle }}</div>
      </template>
      <template slot="popup-tip">
        {{$t('channel.sensitiveWordsManage')}}
      </template>
      <template slot="popup-con">
        <div class="popup-con">
          <div class="field-item-class-c">
            <div class="field-name">
              {{$t('channel.wordName')}}
              <span class="required-mark">*</span>
            </div>
            <el-input 
              v-model="sensitiveWordsForm.word_name" 
              :placeholder="$t('channel.wordNamePlaceholder')"
            />
          </div>
          <div class="field-item-class-c">
            <div class="field-name">{{$t('channel.description')}}</div>
            <el-input
              v-model="sensitiveWordsForm.description"
              type="textarea"
              :rows="3"
              :placeholder="$t('channel.descriptionPlaceholder')"
            />
          </div>
          <div class="field-item-class-c">
            <div class="field-name">
              {{$t('channel.sensitiveWords')}}
              <span class="required-mark">*</span>
            </div>
            <el-input
              v-model="sensitiveWordsForm.sensitive_words"
              type="textarea"
              :rows="4"
              :placeholder="$t('channel.sensitiveWordsPlaceholder')"
            />
            <div class="field-tip">{{$t('channel.sensitiveWordsTip')}}</div>
          </div>
        </div>
      </template>
      <template slot="dialog-footer">
        <el-button class="cancel-btn" @click="closeDialog">{{$t('channel.cancel')}}</el-button>
        <el-button class="confirm-btn" @click="submitForm" :loading="submitLoading">{{$t('channel.confirm')}}</el-button>
      </template>
    </popup>
  </div>
</template>

<script>
import popup from "@/components/popup.vue";
import { formatSensitiveWords, formatDateTime, validateSensitiveWordsData, processSensitiveWords } from "./sensitiveWords/utils";
import config from "./sensitiveWords/config";

export default {
  name: 'SensitiveWordsManage',
  components: {
    popup
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      sensitiveWordsList: [],
      dialogVisible: false,
      dialogTitle: this.$t('channel.addSensitiveWords'),
      sensitiveWordsForm: {
        word_name: '',
        description: '',
        sensitive_words: ''
      }
    }
  },
  computed: {
    filteredSensitiveWordsList() {
      return this.sensitiveWordsList;
    }
  },
  mounted() {
    this.loadSensitiveWordsList();
  },
  methods: {
        // 加载敏感词列表
    async loadSensitiveWordsList() {
      try {
        this.loading = true;
        const mainId = localStorage.getItem('_mainId');
        const response = await this.$http.get(`/openplatform-api/sensitive-words?main_id=${mainId}`);
        
        if (response.data && response.data.sensitive_words) {
          this.sensitiveWordsList = response.data.sensitive_words || [];
        } else if (response.data && Array.isArray(response.data)) {
          this.sensitiveWordsList = response.data || [];
        }
      } catch (error) {
        console.error('获取敏感词列表失败:', error);
        this.$message.error(this.$t('channel.getListFail'));
      } finally {
        this.loading = false;
      }
    },

    // 显示新增对话框
    showAddDialog() {
      this.dialogTitle = this.$t('channel.addSensitiveWords');
      this.dialogVisible = true;
      this.resetForm();
    },

    // 编辑敏感词
    async editSensitiveWords(row) {
      try {
        this.loading = true;
        const mainId = localStorage.getItem('_mainId');
        const response = await this.$http.get(`/openplatform-api/sensitive-words/${row.id}?main_id=${mainId}`);
        
        if (response.data) {
          this.sensitiveWordsForm = { 
            word_name: response.data.word_name,
            description: response.data.description,
            sensitive_words: response.data.sensitive_words,
            id: response.data.id
          };
          this.dialogTitle = this.$t('channel.editSensitiveWords');
          this.dialogVisible = true;
        } else {
          // 如果获取详情失败，直接使用行数据
          this.sensitiveWordsForm = { 
            word_name: row.word_name,
            description: row.description,
            sensitive_words: row.sensitive_words,
            id: row.id
          };
          this.dialogTitle = this.$t('channel.editSensitiveWords');
          this.dialogVisible = true;
        }
      } catch (error) {
        console.error('获取敏感词详情失败:', error);
        // 如果获取详情失败，直接使用行数据
        this.sensitiveWordsForm = { 
          word_name: row.word_name,
          description: row.description,
          sensitive_words: row.sensitive_words,
          id: row.id
        };
        this.dialogTitle = this.$t('channel.editSensitiveWords');
        this.dialogVisible = true;
      } finally {
        this.loading = false;
      }
    },

    // 删除敏感词
    deleteSensitiveWords(row) {
      this.$confirm(this.$t('channel.deleteConfirm'), this.$t('channel.title'), {
        confirmButtonText: this.$t('channel.confirm'),
        cancelButtonText: this.$t('channel.cancel'),
        type: 'warning'
      }).then(async () => {
        try {
          this.loading = true;
          const mainId = localStorage.getItem('_mainId');
          const response = await this.$http.delete(`/openplatform-api/sensitive-words/${row.id}?main_id=${mainId}`);
          
          if (response.data && response.data.code === '0') {
            this.$message.success(this.$t('channel.deleteSuccess'));
            this.loadSensitiveWordsList();
          } else if (response.status === 200 || response.status === 204) {
            this.$message.success(this.$t('channel.deleteSuccess'));
            this.loadSensitiveWordsList();
          } else {
            this.$message.error((response.data && response.data.message) || this.$t('channel.deleteFail'));
          }
        } catch (error) {
          console.error('删除敏感词失败:', error);
          this.$message.error(this.$t('channel.deleteFail'));
        } finally {
          this.loading = false;
        }
      });
    },

    // 提交表单
    async submitForm() {
      // 使用配置的验证规则
      const validation = validateSensitiveWordsData(this.sensitiveWordsForm);
      if (!validation.isValid) {
        this.$message.error(validation.errors[0]);
        return;
      }

      try {
        this.submitLoading = true;
        
        const mainId = localStorage.getItem('_mainId');
        const uid = localStorage.getItem('_uid');
        
        if (!mainId || !uid) {
          this.$message.error(this.$t('channel.userInfoMissing'));
          return;
        }

        const requestData = {
          word_name: this.sensitiveWordsForm.word_name.trim(),
          description: this.sensitiveWordsForm.description.trim(),
          sensitive_words: processSensitiveWords(this.sensitiveWordsForm.sensitive_words.trim()),
          main_id: mainId,
          user_id: uid
        };

        let response;
        if (this.dialogTitle === this.$t('channel.addSensitiveWords')) {
          // 新增敏感词
          response = await this.$http.post('/openplatform-api/sensitive-words', requestData);
        } else {
          // 编辑敏感词
          response = await this.$http.put(`/openplatform-api/sensitive-words/${this.sensitiveWordsForm.id}?main_id=${mainId}`, requestData);
        }
        
        // 处理响应结果
        if (response.data && response.data.id) {
          // 直接返回数据对象的情况
          this.handleSuccessOperation();
        } else if (response.data && response.data.code === '0') {
          // 返回包装格式的情况
          this.handleSuccessOperation();
        } else if (response.status === 200 || response.status === 204) {
          // HTTP状态码成功的情况
          this.handleSuccessOperation();
        } else {
          // 其他情况，检查是否是重名错误
          if (response.data) {
            // 检查是否有嵌套的detail字段
            const errorData = response.data.detail || response.data;
            
            // 检查后端返回的错误代码
            if (errorData.error_code === 'DUPLICATE_NAME') {
              this.$message.error(this.$t('channel.duplicateNameError') || '敏感词组名称已存在，请使用其他名称');
            } else if (errorData.message) {
              const errorMessage = errorData.message;
              
              // 兼容旧的错误信息格式，检查错误信息中是否包含重名相关的关键词
              if (errorMessage.includes('重名') || 
                  errorMessage.includes('重复') || 
                  errorMessage.includes('已存在') ||
                  errorMessage.includes('duplicate') ||
                  errorMessage.includes('exists')) {
                this.$message.error(this.$t('channel.duplicateNameError') || '敏感词组名称已存在，请使用其他名称');
              } else {
                // 显示后端返回的具体错误信息
                this.$message.error(errorMessage);
              }
            } else {
              // 没有具体错误信息时，显示默认提示
              this.$message.error(this.$t('channel.operationFail'));
            }
          } else {
            // 没有返回数据时，显示默认提示
            this.$message.error(this.$t('channel.operationFail'));
          }
        }
      } catch (error) {
        console.error('操作失败:', error);
        
        // 检查是否是重名错误
        if (error.response && error.response.data) {
          // 检查是否有嵌套的detail字段
          const errorData = error.response.data.detail || error.response.data;
          
          // 优先检查后端返回的错误代码
          if (errorData.error_code === 'DUPLICATE_NAME') {
            this.$message.error(this.$t('channel.duplicateNameError') || '敏感词组名称已存在，请使用其他名称');
          } else if (errorData.message) {
            // 兼容旧的错误信息格式，检查错误信息中是否包含重名相关的关键词
            if (errorData.message.includes('重名') || 
                errorData.message.includes('重复') || 
                errorData.message.includes('已存在') ||
                errorData.message.includes('duplicate') ||
                errorData.message.includes('exists')) {
              this.$message.error(this.$t('channel.duplicateNameError') || '敏感词组名称已存在，请使用其他名称');
            } else {
              // 显示后端返回的具体错误信息
              this.$message.error(errorData.message);
            }
          } else {
            // 默认错误提示
            this.$message.error(this.$t('channel.operationFail'));
          }
        } else {
          // 没有详细错误信息时，显示默认提示
          this.$message.error(this.$t('channel.operationFail'));
        }
      } finally {
        this.submitLoading = false;
      }
    },

    // 关闭对话框
    closeDialog() {
      this.dialogVisible = false;
      this.resetForm();
    },

    // 重置表单
    resetForm() {
      this.sensitiveWordsForm = {
        word_name: '',
        description: '',
        sensitive_words: '',
        id: ''
      };
    },

    // 处理成功操作
    handleSuccessOperation() {
      const successMessage = this.dialogTitle === this.$t('channel.addSensitiveWords') ? this.$t('channel.addSuccess') : this.$t('channel.editSuccess');
      this.$message.success(successMessage);
      this.dialogVisible = false;
      this.resetForm();
      this.loadSensitiveWordsList();
    },

    // 格式化日期时间
    formatDateTime(timestamp) {
      return formatDateTime(timestamp, 'YYYY-MM-DD HH:mm');
    },

    // 格式化敏感词显示
    formatSensitiveWords(words) {
      return formatSensitiveWords(words, 10); // 增加到显示10个敏感词
    }
  }
}
</script>

<style scoped lang="less">
.sensitive-words-manage {
  height: 100%;
  .content-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0px;
  }
  
  .toolbar {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
  }

  .toolbar-right {
    display: flex;
    align-items: center;
  }

  .tip-text {
    display: flex;
    align-items: center;
    color: #909399;
    font-size: 14px;
    line-height: 1.4;
    padding: 8px 16px;
    background-color: #f0f9ff;
    border: 1px solid #b3d8ff;
    border-radius: 6px;
    
    i {
      margin-right: 8px;
      color: #409eff;
      font-size: 16px;
    }
  }

  .add-btn {
    color: #fff !important;
    border-radius: 20px !important;
  }

  .delete-btn {
    color: #fff !important;
  }
  
  .el-table {
    flex: 1;
    
    /deep/ .el-table__header {
      background-color: #f5f7fa !important;
      border-top: 2px solid #e8eaed !important;
      border-radius: 4px 4px 0 0 !important;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    }
    
    /deep/ .el-table__body {
      background-color: white !important;
    }
    
    /deep/ .cell {
      color: #333 !important;
    }
  }

  .sensitive-words-content {
    max-width: 100%;
    word-break: break-all;
    line-height: 1.6;
    padding: 10px 16px;
    text-align: left;
    color: #606266;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e9ecef;
    min-height: 40px;
    display: flex;
    align-items: center;
  }
  
  /deep/ .el-input__inner {
    color: #333 !important;
    background-color: white !important;
  }
}

/* 弹窗样式继承自popup.vue */
.popup-con {
  .field-item-class-c {
    .field-name {
      padding-bottom: 8px;
      line-height: 20px;
      color: #616161;
      
      .required-mark {
        color: #f56c6c !important;
        margin-left: 4px;
        font-weight: bold;
      }
    }
    
    .el-input {
      width: 100%;
    }
    
    .el-textarea {
      width: 100%;
    }
    
    .el-button {
      color: #ffffff;
    }
    
    .confirm-btn {
      color: #ffffff !important;
    }

    .field-tip {
      margin-top: 8px;
      font-size: 12px;
      color: #909399;
      line-height: 1.4;
    }
  }
}

/* 确保弹窗中确定按钮的文字颜色是白色 */
/deep/ .popup-floating-layer {
  .confirm-btn {
    color: #ffffff !important;
  }
  
  .el-button--primary {
    color: #ffffff !important;
  }
}
</style> 